<script lang="ts">
  import { Info } from "svelte-feathers"
  import { Milestone, percentageAmount } from "@models/milestones/Milestone"
  import { Package } from "@models/trips/Package"
  import { formatCentsAsUsd } from "@util/money"
  export let milestone: Milestone
  export let milestones: Milestone[]
  export let packages: Package[]
</script>

<span data-role="info-tooltip">
  <Info size="16" strokeWidth={2.0} class="ml-1" />
  <span class="absolute z-50 hidden p-3 mt-4 mr-20 text-center bg-gray-200 border-gray-300 group-hover:block max-w-sm">
    <div class="text-center">
      <i>Percentages payments (%)</i> refer to any money not covered by <i> fixed payments ($)</i>. Depending on the package
      amount, this payment is:<br />
    </div>
    {#each packages as p}
      <div class="grid grid-flow-col mt-1">
        <div>For {p.name}:</div>
        <div class="text-right">
          {formatCentsAsUsd(percentageAmount(milestones, milestone, p))} of {formatCentsAsUsd(p.price)}
        </div>
      </div>
    {/each}
  </span>
</span>
